import PageHeader from '../../components/PageHeader/PageHeader';
import React, { useState, useEffect, useRef, useMemo } from 'react';
// FORCE RECOMPILE - V2
import { Modal, Spinner } from 'react-bootstrap';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import DataTable from 'react-data-table-component';
import { zoomPlugin } from '@react-pdf-viewer/zoom';
import '@react-pdf-viewer/zoom/lib/styles/index.css';
import { urlApiProd } from '../utiles';
import DateInput from '../../components/DateInput/DateInput';
import * as pdfjsLib from 'pdfjs-dist';

const workerUrl = `https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js`;
pdfjsLib.GlobalWorkerOptions.workerSrc = workerUrl;

function SubirArchivos() {
    const [tipoArchivo, setTipoArchivo] = useState('');
    const [lecturaMasiva, setLecturaMasiva] = useState(null);
    const [modeloSeleccionado, setModeloSeleccionado] = useState(null);
    const [dataModelos, setDataModelos] = useState([]);
    const [mensaje, setMensaje] = useState('');
    const [archivoPDF, setArchivoPDF] = useState(null);
    const [archivosPDF, setArchivosPDF] = useState([]);
    const [isUploading, setIsUploading] = useState(false);
    const [notaFiscalData, setNotaFiscalData] = useState({
        nro_nf: '', tipo_nf: '', llave: '', proveedor: '', emision: '', salida: '',
        cnpj: '', valor_productos: '', valor_total: '', pkg: '', descuento: ''
    });
    const [nuevoDetalle, setNuevoDetalle] = useState({
        producto: '', calidad: '', medida: '', ncm: '', m3: '', usd_m3: '', descuento: '', total: '', id_producto: null
    });
    const [detalles, setDetalles] = useState([]);
    const zoomPluginInstance = zoomPlugin();
    const { ZoomInButton, ZoomOutButton, ZoomPopover } = zoomPluginInstance;
    const [totalFiles, setTotalFiles] = useState(0);
    const [uploadedCount, setUploadedCount] = useState(0);
    const [successfulUploads, setSuccessfulUploads] = useState([]);
    const [failedUploads, setFailedUploads] = useState([]);
    const [existingUploads, setExistingUploads] = useState([]);
    const [datosExtraidosMasivos, setDatosExtraidosMasivos] = useState({});
    const [procesandoMasivo, setProcesandoMasivo] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [editingFileName, setEditingFileName] = useState('');
    const [editingData, setEditingData] = useState(null);
    const [manualCount, setManualCount] = useState(1);
    const [submittingManual, setSubmittingManual] = useState(false);
    const [modalActiveSearchIndex, setModalActiveSearchIndex] = useState(null);
    const [modalSearchTerm, setModalSearchTerm] = useState('');

    // Referencias
    const inputFileRef = useRef(null);
    const dropdownRef = useRef(null);

    // Estados para buscador de productos generales
    const [productNames, setProductNames] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [showProductDropdown, setShowProductDropdown] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [availableGrades, setAvailableGrades] = useState([]);

    const handleLecturaMasiva = (e) => {
        const val = parseInt(e.target.value, 10);
        setLecturaMasiva(val);
        setArchivosPDF([]);
        setArchivoPDF(null);
    };

    const formatFileName = (name) => {
        const extIndex = name.lastIndexOf('.');
        const extension = name.substring(extIndex);
        const fileName = name.substring(0, extIndex);
        if (fileName.length > 20) {
            return fileName.substring(0, 20) + "..." + extension;
        }
        return name;
    };

    const handleChangeTipoArchivo = (e) => {
        const value = e.target.value;
        setTipoArchivo(value);
        if (value === 'Nota Fiscal') {
            setLecturaMasiva(2);
        } else {
            setLecturaMasiva(null);
        }
    };

    const fetchModelos = async () => {
        const token = localStorage.getItem('token');
        try {
            const response = await fetch(`${urlApiProd}/proveedores`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            const modelos = await response.json();
            if (Array.isArray(modelos)) {
                setDataModelos(modelos);
            } else {
                console.error('El backend no devolvió un array de proveedores:', modelos);
                setDataModelos([]);
            }
        } catch (error) {
            console.error('Error al obtener modelos:', error);
            setDataModelos([]);
        }
    };

    useEffect(() => {
        // Fetch models once on mount
        fetchModelos();
    }, []);

    useEffect(() => {
        // Ensure models are fetched when we enter a mode that needs them, if they weren't fetched before
        if ((lecturaMasiva === 1 || lecturaMasiva === 2 || tipoArchivo === 'Nota Fiscal') && (!dataModelos || dataModelos.length === 0)) {
            fetchModelos();
        }
    }, [lecturaMasiva, tipoArchivo, dataModelos.length]);

    const fetchProductNames = async () => {
        const token = localStorage.getItem('token');
        try {
            const response = await fetch(`${urlApiProd}/nombreproductos`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (response.ok) {
                const data = await response.json();
                // Eliminar duplicados por nombre antes de guardar en el estado
                const uniqueProducts = [];
                const seenNames = new Set();
                data.forEach(item => {
                    const name = item.nombre_producto?.trim();
                    if (name && !seenNames.has(name)) {
                        seenNames.add(name);
                        uniqueProducts.push(item);
                    }
                });
                setProductNames(uniqueProducts);
            }
        } catch (error) {
            console.error('Error al obtener nombres de productos:', error);
        }
    };

    const fetchGrades = async () => {
        const token = localStorage.getItem('token');
        try {
            const response = await fetch(`${urlApiProd}/opciones`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (response.ok) {
                const data = await response.json();
                if (data.calidades) {
                    setAvailableGrades(data.calidades);
                }
            }
        } catch (error) {
            console.error('Error fetching grades:', error);
        }
    };

    useEffect(() => {
        if (tipoArchivo === 'Nota Fiscal') {
            fetchProductNames();
            fetchGrades();
        }
    }, [tipoArchivo]);

    const validarArchivoIA = (file) => {
        return new Promise((resolve, reject) => {
            // Check Size (100KB)
            const MAX_SIZE = 500 * 1024; // 500KB in bytes
            if (file.size > MAX_SIZE) {
                return reject(new Error(`El archivo ${file.name} es demasiado pesado (${Math.round(file.size / 1024)}KB). El máximo permitido para lectura con IA es 100KB.`));
            }

            // Check Pages (only for PDF)
            if (file.type === 'application/pdf') {
                const reader = new FileReader();
                reader.onload = async () => {
                    try {
                        const typedarray = new Uint8Array(reader.result);
                        const loadingTask = pdfjsLib.getDocument(typedarray);
                        const pdf = await loadingTask.promise;
                        if (pdf.numPages > 5) {
                            reject(new Error(`El archivo ${file.name} tiene ${pdf.numPages} páginas. El máximo permitido para lectura con IA es de 5 páginas.`));
                        } else {
                            resolve(true);
                        }
                    } catch (error) {
                        reject(new Error(`No se pudo leer el archivo PDF ${file.name} para validar sus páginas.`));
                    }
                };
                reader.onerror = () => reject(new Error(`Error al leer el archivo ${file.name}`));
                reader.readAsArrayBuffer(file);
            } else {
                // If it's not a PDF, we already checked size (xml handles its own logic)
                resolve(true);
            }
        });
    };

    // Cerrar dropdown al hacer click fuera
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowProductDropdown(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleFileChange = async (e) => {
        const files = Array.from(e.target.files);
        const isNotaFiscal = tipoArchivo === 'Nota Fiscal';

        if (files.length > 0) {
            setSuccessfulUploads([]);
            setFailedUploads([]);
            setExistingUploads([]);
            setIsUploading(true); // Mostrar spinner mientras validamos
            try {
                if (lecturaMasiva === 2) {
                    let filteredFiles = [];
                    if (isNotaFiscal) {
                        const manualesExistentes = archivosPDF.filter(f => f.isManual);
                        if (manualesExistentes.length > 0) {
                            if (!window.confirm("Tienes notas fiscales creadas manualmente. ¿Deseas descartarlas para cargar la información de los nuevos archivos?")) {
                                setIsUploading(false);
                                return;
                            }
                        }
                        filteredFiles = files.filter((file) => file.name.toLowerCase().endsWith('.xml'));
                        // Validar tamaño de XMLs también si se desea, pero el usuario pidió para IA (Azure/PDF)
                        // Por ahora los XML solo los filtramos por extensión
                        setArchivosPDF(filteredFiles);
                        setDatosExtraidosMasivos({});
                        extraerTodosMasivo(filteredFiles);
                    } else {
                        const pdfFiles = files.filter((file) => file.type === 'application/pdf');
                        const validFiles = [];
                        for (const file of pdfFiles) {
                            try {
                                await validarArchivoIA(file);
                                validFiles.push(file);
                            } catch (error) {
                                alert(error.message);
                            }
                        }
                        if (validFiles.length > 0) {
                            setArchivosPDF(validFiles);
                        }
                    }
                } else if (lecturaMasiva === 1) {
                    const file = files[0];
                    if (file && file.type === 'application/pdf') {
                        await validarArchivoIA(file);
                        setArchivoPDF(file);
                        extraerDatos(file);
                    } else if (file && isNotaFiscal && file.name.toLowerCase().endsWith('.xml')) {
                        setArchivoPDF(file);
                        extraerDatos(file);
                    }
                }
            } catch (error) {
                alert(error.message);
                e.target.value = ''; // Reset input
            } finally {
                setIsUploading(false);
            }
        }
    };

    const extraerTodosMasivo = async (files) => {
        setProcesandoMasivo(true);
        const token = localStorage.getItem('token');
        const nuevosDatos = {};

        const buildFallbackDraft = (fileName, errorMsg = 'No se pudo extraer el XML') => ({
            nro_nf: '',
            tipo_nf: '',
            llave: '',
            proveedor: '',
            emision: '',
            salida: '',
            cnpj: '',
            valor_productos: '',
            valor_total: '',
            pkg: '',
            descuento: '',
            booking: '',
            oc: '',
            productos: [],
            nombre_proveedor: '',
            _parse_warning: `Borrador parcial (${fileName}): ${errorMsg}`,
        });

        for (const file of files) {
            const formData = new FormData();
            formData.append('archivo', file);
            if (selectedProduct) {
                formData.append('productoGeneral', selectedProduct.nombre_producto);
                formData.append('idProductoGeneral', selectedProduct.id_producto);
            }
            try {
                const response = await fetch(`${urlApiProd}/extraer_datos`, {
                    method: 'POST',
                    headers: { 'Authorization': `Bearer ${token}` },
                    body: formData
                });
                if (response.ok) {
                    const data = await response.json();
                    nuevosDatos[file.name] = data;
                } else {
                    let err = `HTTP ${response.status}`;
                    try {
                        const errorPayload = await response.json();
                        err = errorPayload?.error || errorPayload?.mensaje || err;
                    } catch (_) {
                        // ignore parse error and keep generic message
                    }
                    nuevosDatos[file.name] = buildFallbackDraft(file.name, err);
                }
            } catch (error) {
                console.error(`Error extrayendo datos de ${file.name}:`, error);
                nuevosDatos[file.name] = buildFallbackDraft(file.name, error?.message || 'Error de red');
            }
            // Update state progressively to show cards appearing
            setDatosExtraidosMasivos(prev => ({ ...prev, ...nuevosDatos }));
        }
        setProcesandoMasivo(false);
    };

    // extraerDatos is no longer called from handleFileChange as single file processing is removed
    const extraerDatos = async (file) => {
        setIsUploading(true);
        const token = localStorage.getItem('token');
        const formData = new FormData();
        formData.append('archivo', file);

        // Si tenemos un modelo seleccionado, lo enviamos (opcional para XML pero necesario para PDF)
        const proveedor = Array.isArray(dataModelos) ? dataModelos.find(prov => prov.id_proveedor === parseInt(modeloSeleccionado)) : null;
        if (proveedor) {
            formData.append('modeloSeleccionado', proveedor.modelo);
            formData.append('proveedor', parseInt(proveedor.id_proveedor));
        }

        if (selectedProduct) {
            formData.append('productoGeneral', selectedProduct.nombre_producto);
            formData.append('idProductoGeneral', selectedProduct.id_producto);
        }

        try {
            const response = await fetch(`${urlApiProd}/extraer_datos`, {
                method: 'POST',
                headers: { 'Authorization': `Bearer ${token}` },
                body: formData
            });

            if (response.ok) {
                const data = await response.json();
                setNotaFiscalData({
                    nro_nf: data.nro_nf || '',
                    tipo_nf: data.tipo_nf || '',
                    llave: data.llave || '',
                    proveedor: data.proveedor || '',
                    emision: data.emision || '',
                    salida: data.salida || '',
                    cnpj: data.cnpj || '',
                    valor_productos: data.valor_productos || '',
                    valor_total: data.valor_total || '',
                    pkg: data.pkg || '',
                    descuento: data.descuento || '',
                    booking: data.booking || '',
                    oc: data.oc || ''
                });

                if (data.proveedor) {
                    setModeloSeleccionado(data.proveedor);
                    console.log(`Proveedor identificado: ${data.nombre_proveedor}`);
                }

                if (data.productos) {
                    setDetalles(data.productos);
                }
            } else {
                console.error("Error al extraer datos del archivo");
            }
        } catch (error) {
            console.error("Error en la solicitud de extracción:", error);
        } finally {
            setIsUploading(false);
        }
    };

    const archivoPDFUrl = useMemo(() => {
        return archivoPDF ? URL.createObjectURL(archivoPDF) : null;
    }, [archivoPDF]);

    const lectorArchivos = async (files) => {
        setIsUploading(true);
        setTotalFiles(files.length);
        setUploadedCount(0);
        setSuccessfulUploads([]);
        setFailedUploads([]);
        setExistingUploads([]);
        const token = localStorage.getItem('token');
        if (!token) return alert("No se encontró un token de autenticación.");

        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            const formData = new FormData();
            formData.append('archivo', file); // Cambia 'archivos' a 'archivo'
            const proveedor = Array.isArray(dataModelos) ? dataModelos.find(prov => prov.id_proveedor === parseInt(modeloSeleccionado)) : null;
            if (proveedor) {
                formData.append('modeloSeleccionado', proveedor.modelo);
                formData.append('proveedor', parseInt(proveedor.id_proveedor));
            }
            try {
                const response = await fetch(`${urlApiProd}/leerarchivo`, {
                    method: "POST",
                    body: formData,
                });

                const data = await response.json();

                if (response.ok) {
                    setSuccessfulUploads(prev => [...prev, file.name]);
                } else {
                    setFailedUploads(prev => [...prev, { name: file.name, error: data.error || 'Error desconocido' }]);
                }
            } catch (error) {
                console.error(`Error al enviar el archivo ${file.name}:`, error);
                setFailedUploads(prev => [...prev, { name: file.name, error: error.message || 'Error en la solicitud' }]);
            } finally {
                setUploadedCount(prev => prev + 1);
            }
        }
        setIsUploading(false)
    };

    const validarDatosNF = (data) => {
        if (!data) return ["Datos no cargados"];
        // alert("DEBUG: Validando " + (data.nro_nf || "Sin número"));
        console.log("DEBUG VALIDACION:", data);
        const errores = [];

        // Validar Proveedor (debe ser un ID válido)
        const idProv = parseInt(data.proveedor);
        if (isNaN(idProv) || idProv <= 0) errores.push("Proveedor");

        // Validar Nro NF (debe ser un string no vacío y distindo de N/A)
        const nroStr = String(data.nro_nf || '').trim();
        if (!nroStr || nroStr === "" || nroStr.toUpperCase() === "N/A" || nroStr === "0") errores.push("Nro NF");

        // Validar Fecha Emisión
        if (!data.emision || data.emision === "" || data.emision.toUpperCase() === "N/A") errores.push("Fecha Emisión");

        // Validar Valor Total (debe ser > 0)
        let totalVal = 0;
        if (typeof data.valor_total === 'number') {
            totalVal = data.valor_total;
        } else {
            const strVal = String(data.valor_total || '0').trim().replace(/[^0-9,.]/g, '');
            // Manejar formato 1.234,56 o 1234.56
            if (strVal.includes('.') && strVal.includes(',')) {
                totalVal = parseFloat(strVal.replace(/\./g, '').replace(',', '.'));
            } else {
                totalVal = parseFloat(strVal.replace(',', '.'));
            }
        }
        if (isNaN(totalVal) || totalVal <= 0) errores.push("Valor Total");

        // Validar Productos
        if (!Array.isArray(data.productos) || data.productos.length === 0) {
            errores.push("Productos");
        } else {
            const incompleto = data.productos.some(p => !p.producto || p.producto === "" || !p.id_producto);
            if (incompleto) errores.push("Productos sin seleccionar");
        }

        return errores;
    };

    const verificarExistencia = async (id_proveedor, nro_nf) => {
        const token = localStorage.getItem('token');
        try {
            const response = await fetch(`${urlApiProd}/verificar_notafiscal?id_proveedor=${id_proveedor}&nro_nf=${nro_nf}`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            const data = await response.json();
            return data.exists;
        } catch (error) {
            console.error('Error verificando existencia:', error);
            return false;
        }
    };

    const guardarNotasFiscalesMasivo = async () => {
        // Usar archivosPDF directamente para evitar cierres obsoletos
        const archivos = archivosPDF;
        console.log("Submit Masivo - Validando", archivos.length, "archivos");

        // 1. VALIDACIÓN
        const archivosConErrores = [];
        for (const file of archivos) {
            const data = datosExtraidosMasivos[file.name] || {};
            const errs = validarDatosNF(data);
            if (errs.length > 0) {
                archivosConErrores.push(`${file.name}: ${errs.join(', ')}`);
            }
        }

        if (archivosConErrores.length > 0) {
            window.alert("!!! ALERTA DE SEGURIDAD - PROCESO BLOQUEADO !!!\n\nNo se puede guardar porque hay archivos con errores.\n\n" + archivosConErrores.join("\n"));
            return;
        }

        if (!window.confirm("Todos los archivos son válidos. ¿Proceder con la verificación de duplicados?")) {
            return;
        }

        // 2. VERIFICACIÓN DE EXISTENCIA EN DB (Duplicados)
        const archivosExistentes = [];
        for (const file of archivos) {
            const data = datosExtraidosMasivos[file.name] || {};
            if (!data.proveedor || !data.nro_nf) continue;
            const exists = await verificarExistencia(data.proveedor, data.nro_nf);
            if (exists) archivosExistentes.push(file.name);
        }

        const archivosAProcesar = archivos.filter(f => !archivosExistentes.includes(f.name));

        if (archivosExistentes.length > 0) {
            setExistingUploads(archivosExistentes);
            if (archivosAProcesar.length === 0) {
                alert("Todos los archivos seleccionados ya existen en el sistema. Proceso abortado.");
                return;
            }
            if (!window.confirm(`Se omitirán ${archivosExistentes.length} archivos que ya existen en el sistema.\n\n¿Desea guardar los ${archivosAProcesar.length} archivos restantes?`)) {
                return;
            }
        }

        // 3. PROCESO DE CARGA
        setIsUploading(true);
        setTotalFiles(archivosAProcesar.length);
        setUploadedCount(0);
        setSuccessfulUploads([]);
        setFailedUploads([]);
        setExistingUploads(archivosExistentes);
        const token = localStorage.getItem('token');

        for (const file of archivosAProcesar) {
            const data = datosExtraidosMasivos[file.name];
            try {
                const response = await fetch(`${urlApiProd}/agregarnotafiscalcondetalles`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                    body: JSON.stringify({
                        id_proveedor: data.proveedor,
                        tipo_nf: data.tipo_nf,
                        nro_nf: data.nro_nf,
                        llave: data.llave,
                        emision: data.emision,
                        salida: data.salida,
                        cnpj: data.cnpj,
                        valor_productos: data.valor_productos,
                        valor_total: data.valor_total,
                        pkg: data.pkg,
                        descuento: data.descuento,
                        booking: data.booking,
                        detalles: data.productos,
                    }),
                });

                if (response.ok) {
                    setSuccessfulUploads(prev => [...prev, file.name]);
                } else {
                    const errorResp = await response.json();
                    console.error(`Error guardando ${file.name}:`, errorResp);
                    setFailedUploads(prev => [...prev, { name: file.name, error: errorResp.error || 'Error desconocido' }]);
                }
            } catch (error) {
                console.error(`Error guardando ${file.name}:`, error);
                setFailedUploads(prev => [...prev, { name: file.name, error: error.message || 'Error en la solicitud' }]);
            } finally {
                setUploadedCount(prev => prev + 1);
            }
        }
        setIsUploading(false);
    };

    const handleChangeModelo = (e) => {
        setModeloSeleccionado(e.target.value);
    };

    // Descartar un archivo PDF de la lista en lectura masiva
    const descartarArchivo = (index) => {
        const nuevosArchivos = archivosPDF.filter((_, i) => i !== index);
        setArchivosPDF(nuevosArchivos);
    };

    const handleNotaFiscalChange = (field, value) => {
        if (showEditModal) {
            setEditingData(prev => ({ ...(prev || {}), [field]: value }));
        } else {
            setNotaFiscalData(prev => ({ ...prev, [field]: value }));
        }
    };

    const handleOpenEditModal = (fileName, initialData = null) => {
        setEditingFileName(fileName);

        // Si no hay modelos cargados, intentar cargarlos ahora
        if (!dataModelos || dataModelos.length === 0) {
            fetchModelos();
        }

        const sourceData = initialData || datosExtraidosMasivos[fileName];
        if (sourceData) {
            setEditingData(JSON.parse(JSON.stringify(sourceData)));
        } else {
            // Default blank data if none found
            setEditingData({
                nro_nf: '', tipo_nf: '', llave: '', proveedor: '', emision: '', salida: '',
                cnpj: '', valor_productos: '', valor_total: '', pkg: '', descuento: '', booking: '', oc: '',
                productos: [], nombre_proveedor: ''
            });
        }
        setShowEditModal(true);
    };

    const handleSaveEdit = () => {
        setDatosExtraidosMasivos(prev => ({
            ...prev,
            [editingFileName]: editingData
        }));
        setShowEditModal(false);
    };

    const handleNuevaManual = () => {
        const manualName = `NF Manual ${manualCount}`;
        setManualCount(prev => prev + 1);

        const newManualFile = { name: manualName, isManual: true };
        const blankData = {
            nro_nf: '', tipo_nf: '', llave: '', proveedor: '', emision: '', salida: '',
            cnpj: '', valor_productos: '', valor_total: '', pkg: '', descuento: '', booking: '',
            productos: [], nombre_proveedor: '', isManual: true,
            id_producto: selectedProduct ? selectedProduct.id_producto : null,
            producto: selectedProduct ? selectedProduct.nombre_producto : ''
        };

        setArchivosPDF(prev => [...prev, newManualFile]);
        setDatosExtraidosMasivos(prev => ({
            ...prev,
            [manualName]: blankData
        }));

        // Abrir el modal para la nueva entrada pasando los datos directamente
        handleOpenEditModal(manualName, blankData);
    };

    const Click = () => {
        inputFileRef.current.click(); // Simular el clic en el input para abrir el diálogo de selección
    };

    const handleNuevoDetalleChange = (field, value) => setNuevoDetalle({ ...nuevoDetalle, [field]: value });

    const agregarDetalle = () => {
        // Al agregar manualmente, si hay un producto seleccionado en el buscador general, lo heredamos
        const detalleConProducto = {
            ...nuevoDetalle,
            id_producto: nuevoDetalle.id_producto || (selectedProduct ? selectedProduct.id_producto : null),
            producto: nuevoDetalle.producto || (selectedProduct ? selectedProduct.nombre_producto : '')
        };
        setDetalles([...detalles, detalleConProducto]);
        setNuevoDetalle({
            producto: '', calidad: '', medida: '', ncm: '', m3: '', usd_m3: '', descuento: '', total: '', id_producto: null
        });
    };

    const columns = [
        {
            name: 'Nombre del Archivo',
            selector: (row) => row.name,
            sortable: true,
            grow: 2,
        },
        {
            name: 'Acción',
            cell: (row, index) => (
                <button className="btn btn-danger btn-sm" onClick={() => setArchivosPDF(archivosPDF.filter((_, i) => i !== index))}>
                    Descartar
                </button>
            ),
            right: true,
        },
    ];

    const columns2 = [
        { 
            name: 'Producto', 
            cell: row => (
                <span style={{ color: !row.id_producto ? '#dc3545' : 'inherit', fontWeight: !row.id_producto ? 'bold' : 'normal' }}>
                    {row.id_producto ? row.producto : 'Producto no seleccionado'}
                </span>
            ),
            sortable: true 
        },
        { name: 'Calidad', selector: row => row.calidad, sortable: true },
        { name: 'NCM', selector: row => row.ncm, sortable: true },
        { name: 'm3', selector: row => row.m3, sortable: true },
        { name: 'USD/m3', selector: row => row.usd_m3, sortable: true },
        { name: 'Descuento', selector: row => row.descuento, sortable: true },
        { name: 'Total', selector: row => row.total, sortable: true },
        {
            name: 'Acción',
            cell: (row, index) => (
                <button className="btn btn-danger btn-sm" onClick={() => setDetalles(detalles.filter((_, i) => i !== index))}>
                    Eliminar
                </button>
            ),
            right: true,
        },
    ];

    const subidaManual = async () => {
        try {
            const token = localStorage.getItem('token');

            const errores = validarDatosNF({
                ...notaFiscalData,
                productos: detalles
            });

            if (errores.length > 0) {
                alert(`Por favor, completa los siguientes campos obligatorios: ${errores.join(', ')}`);
                return;
            }

            // Verificar si ya existe
            const exists = await verificarExistencia(notaFiscalData.proveedor, notaFiscalData.nro_nf);
            if (exists) {
                alert(`La Nota Fiscal Nro ${notaFiscalData.nro_nf} ya existe para este proveedor.`);
                return;
            }

            if (!token) {
                alert('No se encontró un token de autenticación.');
                return;
            }

            const response = await fetch(`${urlApiProd}/agregarnotafiscalcondetalles`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                body: JSON.stringify({
                    id_proveedor: notaFiscalData.proveedor, // Asegúrate de que este campo sea el id del proveedor
                    tipo_nf: notaFiscalData.tipo_nf,
                    nro_nf: notaFiscalData.nro_nf,
                    llave: notaFiscalData.llave,
                    emision: notaFiscalData.emision,
                    salida: notaFiscalData.salida,
                    cnpj: notaFiscalData.cnpj,
                    valor_productos: notaFiscalData.valor_productos,
                    valor_total: notaFiscalData.valor_total,
                    pkg: notaFiscalData.pkg,
                    descuento: notaFiscalData.descuento,
                    booking: notaFiscalData.booking,
                    detalles: detalles, // Esta es la lista de detalles que has acumulado
                }),
            });

            const data = await response.json();

            if (response.ok) {
                alert('Nota Fiscal y detalles guardados exitosamente.');
                // Opcional: resetear los datos del formulario y los detalles
                setNotaFiscalData({
                    nro_nf: '', tipo_nf: '', llave: '', proveedor: '', emision: '', salida: '',
                    cnpj: '', valor_productos: '', valor_total: '', pkg: '', descuento: ''
                });
                setDetalles([]);
                setArchivoPDF(null);
            } else {
                alert(`Error al guardar la Nota Fiscal: ${data.error || 'Error desconocido'}`);
            }
        } catch (error) {
            console.error('Error en la solicitud:', error);
            alert('Error en la solicitud. Por favor, intenta nuevamente.');
        }
    };

    const handleSubmit = (e) => {
        if (e) e.preventDefault();
        console.log("Submit presionado", { lecturaMasiva, tipoArchivo, archivosCount: archivosPDF.length });

        if (tipoArchivo === 'Nota Fiscal') {
            if (lecturaMasiva === 2 || lecturaMasiva === null) {
                guardarNotasFiscalesMasivo(); // Llamada sin argumentos, usa el estado directamente
            } else {
                subidaManual();
            }
        } else {
            if (lecturaMasiva === 2) {
                lectorArchivos(archivosPDF);
            } else if (lecturaMasiva === 1) {
                subidaManual();
            }
        }
    };

    return (
        <div className="ui-page">
            <PageHeader eyebrow="Lector" title="Subir Archivos para Lectura con IA" descripcion="Carga de archivos para que la IA lea sus datos y los cargue en el sistema." />
            <div className="card">
                <div className="card-body mb-2">
                    {/* Paso 1: Tipo de Archivo */}
                    <div className="input-group mb-3">
                        <label htmlFor="tipoArchivo" className="input-group-text" style={{ width: '170px' }}>Tipo de Archivo:</label>
                        <select id="tipoArchivo" className="form-control" onChange={handleChangeTipoArchivo} value={tipoArchivo}>
                            <option value="">Selecciona un tipo de archivo...</option>
                            <option value="Nota Fiscal">Nota Fiscal</option>
                            <option value="DUE">DUE</option>
                            <option value="Booking confirmation">Confirmación Booking</option>
                        </select>
                    </div>

                    {/* Paso 2: Tipo de Lectura (Solo si NO es Nota Fiscal) */}
                    {(tipoArchivo && tipoArchivo !== 'Nota Fiscal') && (
                        <div className="input-group mb-3">
                            <label htmlFor="lecturaMasiva" className="input-group-text" style={{ width: '170px' }}>Tipo de Lectura:</label>
                            <select id="lecturaMasiva" className="form-control" onChange={handleLecturaMasiva} value={lecturaMasiva || ''}>
                                <option value="">Selecciona el tipo de lectura...</option>
                                <option value={1}>Lectura de Archivo Único (Manual)</option>
                                <option value={2}>Lectura Masiva (Carpeta Completa)</option>
                            </select>
                        </div>
                    )}

                    {/* Paso 2.2: Modelo/Proveedor (Solo si NO es Nota Fiscal y hay un tipo de lectura seleccionado) */}
                    {(tipoArchivo && tipoArchivo !== 'Nota Fiscal' && lecturaMasiva) && (
                        <div className="input-group mb-3">
                            <label htmlFor="modelo" className="input-group-text" style={{ width: '170px' }}>Proveedor:</label>
                            <select id="modelo" className="form-control" onChange={handleChangeModelo} value={modeloSeleccionado}>
                                <option value="">Selecciona un proveedor...</option>
                                {Array.isArray(dataModelos) && dataModelos.length > 0 ? (
                                    dataModelos.map((modelo, index) => (
                                        <option key={index} value={modelo.id_proveedor}>
                                            {modelo.nombre || `ID: ${modelo.id_proveedor}`}
                                        </option>
                                    ))
                                ) : (
                                    <option disabled>No hay proveedores cargados</option>
                                )}
                            </select>
                        </div>
                    )}

                    {/* Buscador de Producto General (Solo para Nota Fiscal) */}
                    {tipoArchivo === 'Nota Fiscal' && (
                        <div className="mb-4 position-relative" ref={dropdownRef}>
                            <label className="form-label fw-bold">Selecciona un producto:</label>
                            <div className="input-group">
                                <span className="input-group-text"><i className="bi bi-search text-primary"></i></span>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Escribe el nombre de un producto..."
                                    value={searchTerm}
                                    onChange={(e) => {
                                        setSearchTerm(e.target.value);
                                        setShowProductDropdown(true);
                                    }}
                                    onFocus={() => setShowProductDropdown(true)}
                                    style={{ borderLeft: 'none' }}
                                />
                                {selectedProduct && (
                                    <button className="btn btn-outline-danger" onClick={() => {
                                        setSelectedProduct(null);
                                        setSearchTerm('');
                                    }}>
                                        <i className="bi bi-x-circle"></i> Limpiar
                                    </button>
                                )}
                            </div>

                            {showProductDropdown && searchTerm.length > 0 && (
                                <div className="list-group position-absolute w-100 shadow-lg" style={{ zIndex: 1050, maxHeight: '250px', overflowY: 'auto', top: '100%' }}>
                                    {productNames
                                        .filter((p) => (p.nombre_producto || '').toLowerCase().includes(searchTerm.toLowerCase()))
                                        .map((p, idx) => (
                                            <button
                                                key={idx}
                                                type="button"
                                                className="list-group-item list-group-item-action"
                                                onClick={() => {
                                                    setSelectedProduct(p);
                                                    setSearchTerm(p.nombre_producto);
                                                    setShowProductDropdown(false);
                                                }}
                                            >
                                                {p.nombre_producto}
                                            </button>
                                        ))
                                    }
                                    {productNames.filter(p => p.nombre_producto.toLowerCase().includes(searchTerm.toLowerCase())).length === 0 && (
                                        <div className="list-group-item disabled text-muted italic">No se encontraron productos coincidentes</div>
                                    )}
                                </div>
                            )}
                            {selectedProduct && (
                                <div className="mt-2 p-2 bg-light rounded border-start border-success border-4 d-flex align-items-center">
                                    <i className="bi bi-check-circle-fill text-success me-2" style={{ fontSize: '1.2rem' }}></i>
                                    <div>
                                        <small className="text-muted d-block">Producto General Seleccionado:</small>
                                        <span className="fw-bold text-success">{selectedProduct.nombre_producto}</span>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}

                    {/* Selección de Archivo/Carpeta */}
                    {(tipoArchivo && (tipoArchivo === 'Nota Fiscal' || lecturaMasiva)) && (
                        <div className="input-group">
                            <button className="btn btn-primary" onClick={Click}>
                                {lecturaMasiva === 2
                                    ? (tipoArchivo === 'Nota Fiscal' ? 'Seleccionar Archivos (XML)' : 'Seleccionar Carpeta (PDF)')
                                    : (tipoArchivo === 'Nota Fiscal' ? 'Seleccionar Archivo (XML)' : 'Seleccionar Archivo (PDF)')}
                            </button>
                            <input
                                ref={inputFileRef}
                                type="file"
                                style={{ display: 'none' }}
                                multiple={lecturaMasiva === 2}
                                webkitdirectory={lecturaMasiva === 2 && tipoArchivo !== 'Nota Fiscal' ? "true" : undefined}
                                onChange={handleFileChange}
                                accept={tipoArchivo === 'Nota Fiscal' ? '.xml' : '.pdf'}
                            />
                        </div>
                    )}
                </div>

                {/* Resultados Masivos */}
                {lecturaMasiva === 2 && (archivosPDF.length > 0 || tipoArchivo === 'Nota Fiscal') && (tipoArchivo === 'Nota Fiscal' || modeloSeleccionado) && (
                    <div className="card-body">
                        {tipoArchivo === 'Nota Fiscal' ? (
                            <div className="row">
                                {/* Card Fija: Creación Manual */}
                                <div className="col-md-4 mb-3">
                                    <div
                                        className="card h-100 shadow-sm border-primary"
                                        style={{ borderStyle: 'dashed', cursor: 'pointer', minHeight: '200px' }}
                                        onClick={handleNuevaManual}
                                    >
                                        <div className="card-body d-flex flex-column align-items-center justify-content-center text-primary py-4">
                                            <i className="bi bi-plus-square-dotted mb-3" style={{ fontSize: '3rem' }}></i>
                                            <h6 className="card-title text-center fw-bold">Creación manual de nota fiscal</h6>
                                            <p className="small text-muted text-center mb-0">Agregar nueva entrada desde cero</p>
                                        </div>
                                    </div>
                                </div>

                                {archivosPDF.map((file, index) => {
                                    const data = datosExtraidosMasivos[file.name] || {};
                                    const errores = validarDatosNF(data);
                                    const hasErrors = errores.length > 0;

                                    return (
                                        <div key={index} className="col-md-4 mb-3">
                                            <div
                                                className={`card h-100 shadow-sm ${hasErrors ? 'border-danger border-4' : (file.isManual ? 'border-success' : 'border-primary')}`}
                                                style={hasErrors ? { outline: '5px solid #dc3545', backgroundColor: '#fff5f5' } : {}}
                                            >
                                                {hasErrors && (
                                                    <div className="bg-danger text-white text-center py-1 small fw-bold">
                                                        FALTA: {errores.join(', ')}
                                                    </div>
                                                )}
                                                <div className="card-header bg-light py-2 d-flex justify-content-between align-items-center">
                                                    <h6 className="card-title mb-0 text-truncate" title={file.name} style={{ maxWidth: '75%' }}>
                                                        <i className={`bi ${file.isManual ? 'bi-pencil-fill' : 'bi-file-earmark-code'} me-2`}></i>
                                                        {formatFileName(file.name)}
                                                    </h6>
                                                    <div className="d-flex align-items-center">
                                                        <button
                                                            type="button"
                                                            className="btn btn-outline-primary btn-sm p-1 me-2"
                                                            onClick={() => handleOpenEditModal(file.name)}
                                                            title="Editar información"
                                                            disabled={!data}
                                                            style={{ fontSize: '0.75rem', lineHeight: '1' }}
                                                        >
                                                            <i className="bi bi-pencil-square me-1"></i>
                                                            Editar
                                                        </button>
                                                        <button
                                                            type="button"
                                                            className="btn-close"
                                                            aria-label="Close"
                                                            style={{ fontSize: '0.8rem' }}
                                                            onClick={() => {
                                                                if (window.confirm(`¿Realmente desea descartar el archivo "${file.name}"?`)) {
                                                                    const nuevos = archivosPDF.filter((_, i) => i !== index);
                                                                    setArchivosPDF(nuevos);
                                                                    // Also remove from extracted data if present
                                                                    const nuevosDatos = { ...datosExtraidosMasivos };
                                                                    delete nuevosDatos[file.name];
                                                                    setDatosExtraidosMasivos(nuevosDatos);
                                                                }
                                                            }}
                                                        ></button>
                                                    </div>
                                                </div>
                                                <div className="card-body py-2" style={{ fontSize: '0.82rem' }}>
                                                    {data ? (
                                                        <>
                                                            <div className="row g-1 mb-2">
                                                                <div className="col-6"><strong>Nro NF:</strong> {data.nro_nf || 'N/A'}</div>
                                                                <div className="col-6"><strong>Fecha:</strong> {data.emision || 'N/A'}</div>
                                                            </div>
                                                            <div className="mb-1 text-truncate" title={data.nombre_proveedor}>
                                                                <strong>Proveedor:</strong> {data.nombre_proveedor || 'No identificado'}
                                                            </div>
                                                            <div className="mb-1 text-truncate" title={data.llave}>
                                                                <strong>Llave:</strong> <span className="text-muted">{data.llave || 'N/A'}</span>
                                                            </div>
                                                            <div className="row g-1 mb-2">
                                                                <div className="col-6"><strong>CNPJ:</strong> {data.cnpj || 'N/A'}</div>
                                                                <div className="col-6 text-end"><span className="badge bg-info text-dark">{data.tipo_nf === '1' ? 'Salida' : 'Entrada'}</span></div>
                                                            </div>
                                                            <div className="row g-1 mb-2 border-top pt-1">
                                                                <div className="col-6"><strong>Prod:</strong> ${data.valor_productos || '0.00'}</div>
                                                                <div className="col-6 text-end"><strong>Total:</strong> ${data.valor_total || '0.00'}</div>
                                                            </div>
                                                            {data.booking && <div className="mb-1"><strong>Booking:</strong> {data.booking}</div>}

                                                            <div className="mt-2 border-top pt-2">
                                                                <h6 style={{ fontSize: '0.8rem', fontWeight: 'bold' }}>Productos ({data.productos?.length || 0})</h6>
                                                                <DataTable
                                                                    columns={[
                                                                        { 
                                                                            name: 'Prod', 
                                                                            cell: row => (
                                                                                <span style={{ color: !row.id_producto ? '#dc3545' : 'inherit', fontWeight: !row.id_producto ? 'bold' : 'normal' }}>
                                                                                    {row.id_producto ? row.producto : 'Producto no seleccionado'}
                                                                                </span>
                                                                            ),
                                                                            sortable: true, 
                                                                            grow: 2 
                                                                        },
                                                                        { name: 'Calidad', selector: row => row.calidad, sortable: true, width: '70px' },
                                                                        { name: 'm3', selector: row => row.m3, sortable: true, width: '60px' },
                                                                        { name: 'Total', selector: row => row.total, sortable: true, width: '80px' },
                                                                    ]}
                                                                    data={data.productos || []}
                                                                    noHeader
                                                                    dense
                                                                    persistTableHead
                                                                />
                                                            </div>
                                                        </>
                                                    ) : (
                                                        <div className="text-center py-5 text-muted">
                                                            <span className="spinner-border spinner-border-sm me-2"></span>
                                                            Obteniendo información...
                                                        </div>
                                                    )}
                                                </div>
                                                {/* Footer removed, action moved to header X */}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        ) : (
                            <DataTable
                                title={`Archivos Seleccionados (${tipoArchivo === 'Nota Fiscal' ? 'XML' : 'PDF'})`}
                                columns={columns}
                                data={archivosPDF}
                                pagination
                                highlightOnHover
                                striped
                            />
                        )}
                    </div>
                )}

                {/* Visualizador y Formulario Manual */}
                {lecturaMasiva === 1 && archivoPDF && (
                    <div className="row mt-3 mb-3 p-3">
                        <div className="col-md-6 mb-4">
                            {archivoPDF.type === 'application/pdf' ? (
                                <Worker workerUrl={workerUrl}>
                                    <div style={{ display: 'flex', flexDirection: 'column', height: '750px' }}>
                                        <div style={{ padding: '0.5rem', display: 'flex', alignItems: 'center' }}>
                                            <ZoomOutButton />
                                            <ZoomPopover />
                                            <ZoomInButton />
                                        </div>
                                        <div style={{ flex: 1, overflow: 'hidden' }}>
                                            <Viewer
                                                fileUrl={archivoPDFUrl}
                                                plugins={[zoomPluginInstance]}
                                            />
                                        </div>
                                    </div>
                                </Worker>
                            ) : (
                                <div className="p-5 border text-center bg-light">
                                    <i className="bi bi-file-earmark-code" style={{ fontSize: '4rem' }}></i>
                                    <h4>Archivo XML</h4>
                                    <p className="text-muted">Los archivos XML se procesan directamente.</p>
                                </div>
                            )}
                        </div>
                        <div className="col-md-6">
                            <form className="p-3 border rounded bg-white">
                                <h5>Información Extraída</h5>
                                <div className="mb-3">
                                    <label className="form-label">Nro Nota Fiscal</label>
                                    <input type="text" className="form-control" value={notaFiscalData.nro_nf} onChange={(e) => handleNotaFiscalChange('nro_nf', e.target.value)} />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Tipo Nota Fiscal</label>
                                    <select className="form-control" value={notaFiscalData.tipo_nf} onChange={(e) => handleNotaFiscalChange('tipo_nf', e.target.value)}>
                                        <option value="">Selecciona tipo...</option>
                                        <option value="0">Entrada (0)</option>
                                        <option value="1">Salida (1)</option>
                                    </select>
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Llave</label>
                                    <input type="text" className="form-control" value={notaFiscalData.llave} onChange={(e) => handleNotaFiscalChange('llave', e.target.value)} />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">RUT/CNPJ</label>
                                    <input type="text" className="form-control" value={notaFiscalData.cnpj} readOnly />
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <label className="form-label">Fecha Emisión</label>
                                        <DateInput value={notaFiscalData.emision} onChange={(e) => handleNotaFiscalChange('emision', e.target.value)} />
                                    </div>
                                    <div className="col">
                                        <label className="form-label">Fecha Salida</label>
                                        <DateInput value={notaFiscalData.salida} onChange={(e) => handleNotaFiscalChange('salida', e.target.value)} />
                                    </div>
                                </div>
                                <div className="row mt-3">
                                    <div className="col">
                                        <label className="form-label">Total Prod. (USD)</label>
                                        <input type="number" step="0.01" className="form-control" value={notaFiscalData.valor_productos} onChange={(e) => handleNotaFiscalChange('valor_productos', e.target.value)} />
                                    </div>
                                    <div className="col">
                                        <label className="form-label">Total NF (USD)</label>
                                        <input type="number" step="0.01" className="form-control" value={notaFiscalData.valor_total} onChange={(e) => handleNotaFiscalChange('valor_total', e.target.value)} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6 mb-3">
                                        <label className="form-label">Booking</label>
                                        <input type="text" className="form-control" value={notaFiscalData.booking} onChange={(e) => handleNotaFiscalChange('booking', e.target.value)} />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label className="form-label">OC</label>
                                        <input type="text" className="form-control" placeholder="XXXX-XX" value={notaFiscalData.oc || ''} onChange={(e) => handleNotaFiscalChange('oc', e.target.value)} />
                                    </div>
                                </div>
                                <h6 className="mt-4">Productos</h6>
                                <DataTable columns={columns2} data={detalles} noHeader dense pagination />
                            </form>
                        </div>
                    </div>
                )}

                {/* Resumen de Procesamiento Masivo */}
                {!isUploading && (successfulUploads.length > 0 || failedUploads.length > 0 || existingUploads.length > 0) && (
                    <div className="card-footer">
                        <h6>Resumen del Proceso:</h6>
                        {successfulUploads.length > 0 && (
                            <div className="alert alert-success py-2 px-3 mb-2">
                                <strong>Exitosos ({successfulUploads.length}):</strong> {successfulUploads.join(', ')}
                            </div>
                        )}
                        {existingUploads.length > 0 && (
                            <div className="alert alert-info py-2 px-3 mb-2">
                                <strong>Ya existían en la base de datos ({existingUploads.length}):</strong>
                                <ul className="mb-0 mt-2 list-unstyled">
                                    {existingUploads.map((name, i) => (
                                        <li key={i} className="d-flex align-items-center py-1 border-bottom border-info border-opacity-25">
                                            <i className="bi bi-info-circle-fill text-info me-2"></i>
                                            <span className="fw-bold text-truncate" style={{ maxWidth: '80%' }}>{name}</span>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}
                        {failedUploads.length > 0 && (
                            <div className="alert alert-danger py-2 px-3 mb-0">
                                <strong>Fallidos ({failedUploads.length}):</strong>
                                <ul className="mb-0 mt-2 list-unstyled">
                                    {failedUploads.map((f, i) => (
                                        <li key={i} className="d-flex justify-content-between align-items-start border-bottom py-1">
                                            <span className="fw-bold me-3 text-truncate" style={{ maxWidth: '40%' }}>{f.name}</span>
                                            <span className="text-end small flex-grow-1">{f.error}</span>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}
                    </div>
                )}

                {/* Footer con Botón de Subida */}
                {((lecturaMasiva === 2 && archivosPDF.length > 0 && (tipoArchivo === 'Nota Fiscal' || modeloSeleccionado)) || (lecturaMasiva === 1 && archivoPDF)) && (
                    <div className="card-footer" style={{ textAlign: 'center' }}>
                        <button className="btn btn-success" onClick={handleSubmit} disabled={isUploading || procesandoMasivo}>
                            {isUploading ? <Spinner animation="border" size="sm" /> : <i className="bi bi-save-fill me-2"></i>}
                            {tipoArchivo === 'Nota Fiscal' ? 'Guardar Resultados' : 'Subir Archivos'}
                        </button>
                    </div>
                )}
            </div>

            {/* Modal de Carga - Solo para Nota Fiscal */}
            <Modal show={isUploading && tipoArchivo === 'Nota Fiscal'} backdrop="static" keyboard={false} centered>
                <Modal.Header>
                    <Modal.Title>{totalFiles > 0 ? 'Procesando Archivos' : 'Analizando Nota Fiscal'}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center">
                    <Spinner animation="border" className="text-primary mb-3" role="status" />
                    {totalFiles > 0 ? (
                        <>
                            <p className="mt-2 fw-bold">Guardando archivos: {uploadedCount}/{totalFiles}</p>
                            <progress value={uploadedCount} max={totalFiles} style={{ width: '100%', height: '20px', borderRadius: '10px' }}></progress>
                            <div className="small text-muted mt-1">Por favor, no cierres la ventana.</div>
                        </>
                    ) : (
                        <p className="mt-2 fw-bold">Extrayendo información del archivo XML...</p>
                    )}
                </Modal.Body>
            </Modal>

            {/* Modal de Edición de Datos Extraídos */}
            <Modal show={showEditModal} onHide={() => setShowEditModal(false)} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Editar Información: {editingFileName}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {editingData && (
                        <form className="row">
                            <div className="col-md-6 mb-3">
                                <label className="form-label fw-bold">Número Nota Fiscal</label>
                                <input type="text" className="form-control" value={editingData.nro_nf || ''} onChange={(e) => handleNotaFiscalChange('nro_nf', e.target.value)} />
                            </div>
                            <div className="col-md-6 mb-3">
                                <label className="form-label fw-bold">Tipo Nota Fiscal</label>
                                <select className="form-control" value={editingData.tipo_nf || ''} onChange={(e) => handleNotaFiscalChange('tipo_nf', e.target.value)}>
                                    <option value="">Selecciona tipo...</option>
                                    <option value="0">Entrada (0)</option>
                                    <option value="1">Salida (1)</option>
                                </select>
                            </div>
                            <div className="col-md-6 mb-3">
                                <label className="form-label fw-bold">Llave</label>
                                <input type="text" className="form-control" value={editingData.llave || ''} onChange={(e) => handleNotaFiscalChange('llave', e.target.value)} />
                            </div>
                            <div className="col-md-6 mb-3">
                                <label className="form-label fw-bold">OC</label>
                                <input type="text" className="form-control" placeholder="XXXX-XX" value={editingData.oc || ''} onChange={(e) => handleNotaFiscalChange('oc', e.target.value)} />
                            </div>
                            <div className="col-md-6 mb-3">
                                <label className="form-label fw-bold">CNPJ/RUT</label>
                                <input type="text" className="form-control" value={editingData.cnpj || ''} onChange={(e) => handleNotaFiscalChange('cnpj', e.target.value)} />
                            </div>
                            <div className="col-md-6 mb-3">
                                <label className="form-label fw-bold">Proveedor</label>
                                <select
                                    className="form-control"
                                    value={editingData.proveedor || ''}
                                    onChange={(e) => {
                                        const selectedId = e.target.value;
                                        const prov = Array.isArray(dataModelos) ? dataModelos.find(p => p.id_proveedor === parseInt(selectedId)) : null;
                                        setEditingData({
                                            ...editingData,
                                            proveedor: selectedId,
                                            nombre_proveedor: prov ? prov.nombre : ''
                                        });
                                    }}
                                >
                                    <option value="">Selecciona un proveedor...</option>
                                    {Array.isArray(dataModelos) && dataModelos.length > 0 ? (
                                        dataModelos.map((modelo, index) => (
                                            <option key={index} value={modelo.id_proveedor}>
                                                {modelo.nombre || `ID: ${modelo.id_proveedor}`}
                                            </option>
                                        ))
                                    ) : (
                                        <option disabled>No hay proveedores cargados</option>
                                    )}
                                </select>
                            </div>
                            <div className="col-md-6 mb-3">
                                <label className="form-label fw-bold">Fecha Emisión</label>
                                <DateInput value={editingData.emision || ''} onChange={(e) => handleNotaFiscalChange('emision', e.target.value)} />
                            </div>
                            <div className="col-md-6 mb-3">
                                <label className="form-label fw-bold">Fecha Salida</label>
                                <DateInput value={editingData.salida || ''} onChange={(e) => handleNotaFiscalChange('salida', e.target.value)} />
                            </div>
                            <div className="col-md-4 mb-3">
                                <label className="form-label fw-bold">Total Prod. (USD)</label>
                                <input type="number" step="0.01" className="form-control" value={editingData.valor_productos || ''} onChange={(e) => handleNotaFiscalChange('valor_productos', e.target.value)} />
                            </div>
                            <div className="col-md-4 mb-3">
                                <label className="form-label fw-bold">Total NF (USD)</label>
                                <input type="number" step="0.01" className="form-control" value={editingData.valor_total || ''} onChange={(e) => handleNotaFiscalChange('valor_total', e.target.value)} />
                            </div>
                            <div className="col-md-4 mb-3">
                                <label className="form-label fw-bold">Booking</label>
                                <input type="text" className="form-control" value={editingData.booking || ''} onChange={(e) => handleNotaFiscalChange('booking', e.target.value)} />
                            </div>



                            <div className="col-12 mt-3">
                                <div className="d-flex justify-content-between align-items-center border-bottom pb-2 mb-2">
                                    <h6 className="mb-0">Productos ({editingData.productos?.length || 0})</h6>
                                    <button
                                        type="button"
                                        className="btn btn-sm btn-success"
                                        onClick={() => {
                                            const newProds = [...(editingData.productos || [])];
                                            newProds.push({
                                                id_producto: editingData.id_producto || (selectedProduct ? selectedProduct.id_producto : null),
                                                producto: editingData.producto || (selectedProduct ? selectedProduct.nombre_producto : ''),
                                                calidad: '',
                                                medida: '',
                                                ncm: '',
                                                m3: 0,
                                                usd_m3: 0,
                                                total: 0,
                                                descuento: '0'
                                            });
                                            setEditingData({ ...editingData, productos: newProds });
                                        }}
                                    >
                                        <i className="bi bi-plus-circle me-1"></i> Agregar Producto
                                    </button>
                                </div>
                                <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                                    <table className="table table-sm table-bordered align-middle">
                                        <thead className="table-light">
                                            <tr className="text-center">
                                                <th>Producto / Grado</th>
                                                <th style={{ width: '90px' }}>m3</th>
                                                <th style={{ width: '90px' }}>BRL/m3</th>
                                                <th style={{ width: '100px' }}>Total</th>
                                                <th style={{ width: '50px' }}></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {(editingData.productos || []).map((p, idx) => (
                                                <tr key={idx}>
                                                    <td>
                                                        <div className="d-flex flex-column gap-1">
                                                            <select
                                                                className="form-select form-select-sm"
                                                                value={p.producto || ''}
                                                                onChange={(e) => {
                                                                    const selectedName = e.target.value;
                                                                    const prodObj = productNames.find(prod => prod.nombre_producto === selectedName);
                                                                    const newProds = [...editingData.productos];
                                                                    newProds[idx].producto = selectedName;
                                                                    newProds[idx].id_producto = prodObj ? prodObj.id_producto : null;
                                                                    setEditingData({ ...editingData, productos: newProds });
                                                                }}
                                                            >
                                                                <option value="">Selecciona Producto...</option>
                                                                {productNames.map((prod, pidx) => (
                                                                    <option key={pidx} value={prod.nombre_producto}>
                                                                        {prod.nombre_producto}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                            <select
                                                                className="form-select form-select-sm"
                                                                style={{ width: '100%' }}
                                                                value={p.calidad || ''}
                                                                onChange={(e) => {
                                                                    const newProds = [...editingData.productos];
                                                                    newProds[idx].calidad = e.target.value;
                                                                    setEditingData({ ...editingData, productos: newProds });
                                                                }}
                                                            >
                                                                <option value="">Selecciona Grado...</option>
                                                                {availableGrades.map((g, i) => (
                                                                    <option key={i} value={g.calidad}>{g.calidad}</option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="number"
                                                            step="0.001"
                                                            className="form-control form-control-sm"
                                                            value={p.m3 || ''}
                                                            onChange={(e) => {
                                                                const newProds = [...editingData.productos];
                                                                newProds[idx].m3 = e.target.value;
                                                                if (newProds[idx].usd_m3) {
                                                                    newProds[idx].total = (parseFloat(e.target.value) * parseFloat(newProds[idx].usd_m3)).toFixed(2);
                                                                }
                                                                setEditingData({ ...editingData, productos: newProds });
                                                            }}
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="number"
                                                            step="0.01"
                                                            className="form-control form-control-sm"
                                                            value={p.usd_m3 || ''}
                                                            onChange={(e) => {
                                                                const newProds = [...editingData.productos];
                                                                newProds[idx].usd_m3 = e.target.value;
                                                                if (newProds[idx].m3) {
                                                                    newProds[idx].total = (parseFloat(e.target.value) * parseFloat(newProds[idx].m3)).toFixed(2);
                                                                }
                                                                setEditingData({ ...editingData, productos: newProds });
                                                            }}
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="number"
                                                            step="0.01"
                                                            className="form-control form-control-sm"
                                                            value={p.total || ''}
                                                            onChange={(e) => {
                                                                const newProds = [...editingData.productos];
                                                                newProds[idx].total = e.target.value;
                                                                setEditingData({ ...editingData, productos: newProds });
                                                            }}
                                                        />
                                                    </td>
                                                    <td className="text-center">
                                                        <button
                                                            type="button"
                                                            className="btn btn-link text-danger p-0"
                                                            onClick={() => {
                                                                const newProds = editingData.productos.filter((_, i) => i !== idx);
                                                                setEditingData({ ...editingData, productos: newProds });
                                                            }}
                                                        >
                                                            <i className="bi bi-trash"></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </form>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-secondary" onClick={() => setShowEditModal(false)}>Cancelar</button>
                    <button className="btn btn-primary" onClick={handleSaveEdit}>Actualizar Cambios</button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default SubirArchivos;
